export default __webpack_public_path__ + "static/media/starFav.c048b6e2.svg";